import { objectToSnakeCase, objectToCamelCase } from '../utils'

import api from './api'

export default class Payment {
  static api = api.create(Payment)
  static readOnlyFields = ['id']

  constructor({
    id = '',
    datetimeCreated = '',
    payout = '',
    lastEdited = '',
    amount = null,
    feeCharged = 0,
    totalAmountCharged = 0,
    currency = '',
    funder = '',
    funderRef = {},
    goal = '',
    goalRef = {},
    description = '',
    paymentSource = '',
    status = '',
    statementDescriptor = '',
    failed = false,
    refunded = false,
    chargeId = '',
  } = {}) {
    Object.assign(this, {
      id,
      datetimeCreated,
      payout,
      lastEdited,
      amount,
      feeCharged,
      totalAmountCharged,
      currency,
      funder,
      funderRef,
      goal,
      goalRef,
      description,
      paymentSource,
      status,
      statementDescriptor,
      failed,
      refunded,
      chargeId,
    })
  }

  copy() {
    return new Payment(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Payment(data)
  }

  static fromAPI(json = {}) {
    const jsonCamel = objectToCamelCase(json)
    return new Payment(jsonCamel)
  }
  /**
   *  Prep Payment data for the API. Can elect to include
   *  or exlude specific fields. The `Payment.readOnlyFields`
   *  are always excluded.
   **/

  static toAPI(payment, fields = [], excludeFields = []) {
    // By default, send the whole update
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = payment[field]
      })
    } else {
      data = payment
    }

    excludeFields = [...Payment.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Payment)) {
      throw Error(`${name} must be an instance of the Update class.`)
    }
  }
}
